function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#189418",
  d: "M10.972 4.85l-8.39 6.293-.028-4.107 8.39-6.292 8.475 6.178.027 4.106-8.474-6.178z",
  fill: "#fff"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#189418",
  d: "M9 6.599v13.542M13 6.599v13.542"
});
function SvgDoubleArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgDoubleArrowUp;